// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-info-box[data-v-6bc85b49] {\n  display: flex;\n  padding: 20px 16px;\n  align-items: center;\n  gap: 16px;\n  border-radius: 4px;\n  color: #455A64;\n  background: #FFF1CC;\n  margin-bottom: 40px;\n}\n.panel-info-box-content[data-v-6bc85b49] {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.panel-info-box svg[data-v-6bc85b49] {\n  flex-shrink: 0;\n}\n", ""]);
// Exports
module.exports = exports;
